(function() {
  var MOBILE_QUERY = '(max-width: 989px)';
  var MAX_MOBILE_COLLECTION_ITEMS = 60;

  function isMobile() {
    return window.matchMedia && window.matchMedia(MOBILE_QUERY).matches;
  }

  function isStorefrontPath() {
    return /^\/(collections|products|pages|blogs|search)(\/|$)/.test(window.location.pathname) ||
      window.location.pathname === '/';
  }

  function markMobileStablePage() {
    if (!isMobile() || !isStorefrontPath()) return;
    document.documentElement.classList.add('bgtcg-mobile-stability-core');
  }

  function guardReloadMethods() {
    if (!isMobile() || !isStorefrontPath()) return;

    try {
      var key = 'bgtcg-mobile-last-load:' + window.location.pathname + window.location.search;
      var now = Date.now();
      var last = Number(sessionStorage.getItem(key) || 0);
      sessionStorage.setItem(key, String(now));
      if (last && now - last < 8000) {
        document.documentElement.classList.add('bgtcg-mobile-reloaded-recently');
      }
    } catch (error) {}

    try {
      var nativeReload = window.location.reload.bind(window.location);
      Object.defineProperty(window.location, 'reload', {
        configurable: true,
        value: function() {
          if (isMobile() && isStorefrontPath()) return;
          return nativeReload();
        }
      });
    } catch (error) {}
  }

  function trimMobileCollection() {
    if (!isMobile() || !/^\/collections(\/|$)/.test(window.location.pathname)) return;

    var grid = document.querySelector('#ProductGridContainer');
    if (!grid) return;

    var items = Array.from(grid.querySelectorAll('.grid__item'));
    if (items.length <= MAX_MOBILE_COLLECTION_ITEMS) return;

    items.slice(MAX_MOBILE_COLLECTION_ITEMS).forEach(function(item) {
      item.querySelectorAll('img').forEach(function(img) {
        img.removeAttribute('src');
        img.removeAttribute('srcset');
      });
      item.remove();
    });

    grid.classList.add('bgtcg-mobile-trimmed-grid');
  }

  function injectMobileRarityStyles() {
    if (!isMobile() || document.getElementById('bgtcg-mobile-rarity-inline-style')) return;
    var style = document.createElement('style');
    style.id = 'bgtcg-mobile-rarity-inline-style';
    style.textContent = [
      'main#MainContent #ProductGridContainer .collection-top-filter,main#MainContent .bgtcg-mobile-collection .collection-top-filter{display:block!important;background:#111!important;border-top:2px solid #f7b500!important;border-bottom:2px solid #f7b500!important;padding:10px 10px 12px!important;overflow:hidden!important;}',
      'main#MainContent #ProductGridContainer .filter-group,main#MainContent .bgtcg-mobile-collection .filter-group{display:block!important;margin:0 0 10px!important;}',
      'main#MainContent #ProductGridContainer .filter-group__label,main#MainContent .bgtcg-mobile-collection .filter-group__label{display:block!important;width:100%!important;margin:0 0 6px!important;color:#f7b500!important;font-size:12px!important;font-weight:900!important;line-height:1.15!important;letter-spacing:.12em!important;text-transform:uppercase!important;white-space:nowrap!important;}',
      'main#MainContent #ProductGridContainer .filter-group__options,main#MainContent .bgtcg-mobile-collection .filter-group__options{display:flex!important;flex-wrap:nowrap!important;justify-content:flex-start!important;gap:7px!important;width:100%!important;overflow-x:auto!important;overflow-y:hidden!important;-webkit-overflow-scrolling:touch!important;scrollbar-width:none!important;}',
      'main#MainContent #ProductGridContainer .filter-btn,main#MainContent .bgtcg-mobile-collection .filter-btn{flex:0 0 auto!important;min-width:62px!important;min-height:38px!important;padding:8px 12px!important;border:1px solid #f7b500!important;border-radius:6px!important;background:#333!important;color:#fff!important;font-size:14px!important;font-weight:800!important;line-height:1!important;}',
      'main#MainContent #ProductGridContainer .filter-btn.active,main#MainContent .bgtcg-mobile-collection .filter-btn.active{background:#f7b500!important;color:#111!important;}',
      'main#MainContent #ProductGridContainer .filter-reset,main#MainContent .bgtcg-mobile-collection .filter-reset{display:block!important;width:100%!important;min-height:38px!important;margin:2px 0 0!important;padding:8px 12px!important;border-radius:6px!important;background:#242424!important;color:rgba(255,255,255,.78)!important;font-size:14px!important;font-weight:700!important;line-height:1!important;}',
      'main#MainContent #ProductGridContainer .bgtcg-js-rarity-section{display:block!important;margin:0 0 22px!important;}',
      'main#MainContent #ProductGridContainer .bgtcg-js-rarity-section>.rarity-title{display:block!important;margin:14px 0 10px!important;padding:10px 12px!important;background:#f7b500!important;color:#fff!important;border:0!important;border-radius:8px!important;font-size:17px!important;font-weight:900!important;line-height:1.15!important;letter-spacing:.08em!important;text-transform:uppercase!important;}',
      'main#MainContent #ProductGridContainer .bgtcg-js-rarity-section>.product-grid{display:grid!important;grid-template-columns:repeat(2,minmax(0,1fr))!important;gap:12px!important;}'
    ].join('');
    document.head.appendChild(style);
  }

  function buildMobileRaritySections() {
    if (!isMobile() || !/^\/collections(\/|$)/.test(window.location.pathname)) return;
    injectMobileRarityStyles();

    var container = document.getElementById('ProductGridContainer');
    if (!container || container.querySelector('.bgtcg-js-rarity-section')) return;
    var grid = container.querySelector('ul.product-grid');
    if (!grid || grid.classList.contains('bgtcg-rarity-grouped')) return;

    var items = Array.from(grid.children).filter(function(item) {
      return item.classList && item.classList.contains('grid__item') && item.hasAttribute('data-rarity');
    });
    if (!items.length) return;

    var hasSingleCards = items.some(function(item) {
      return item.querySelector('.product-card-wrapper:not(.bgtcg-non-single-card)');
    });
    if (!hasSingleCards) return;

    var orderedRarities = Array.from(document.querySelectorAll('#rarityFilterBtns button[data-rarity]'))
      .map(function(button) { return button.getAttribute('data-rarity'); })
      .filter(function(rarity) { return rarity && rarity !== 'all'; });
    var buckets = {};
    items.forEach(function(item) {
      var rarity = item.getAttribute('data-rarity') || '其他';
      if (!buckets[rarity]) buckets[rarity] = [];
      buckets[rarity].push(item);
    });
    Object.keys(buckets).forEach(function(rarity) {
      if (orderedRarities.indexOf(rarity) === -1) orderedRarities.push(rarity);
    });

    var fragment = document.createDocumentFragment();
    orderedRarities.forEach(function(rarity) {
      var rarityItems = buckets[rarity];
      if (!rarityItems || !rarityItems.length) return;
      var section = document.createElement('div');
      section.className = 'rarity-section bgtcg-js-rarity-section';
      section.setAttribute('data-rarity', rarity);
      var title = document.createElement('h2');
      title.className = 'rarity-title';
      title.innerHTML = rarity + ' <span class="rarity-count">(' + rarityItems.length + ')</span>';
      var sectionGrid = grid.cloneNode(false);
      sectionGrid.classList.add('bgtcg-rarity-grouped');
      rarityItems.forEach(function(item) {
        sectionGrid.appendChild(item);
      });
      section.appendChild(title);
      section.appendChild(sectionGrid);
      fragment.appendChild(section);
    });

    if (!fragment.childNodes.length) return;
    grid.replaceWith(fragment);
    if (typeof window.applyFilters === 'function') window.applyFilters();
  }

  function stabilizeMobileImages(root) {
    if (!isMobile()) return;
    root = root || document;

    root.querySelectorAll('img').forEach(function(img, index) {
      img.setAttribute('decoding', 'async');
      if (index > 2) {
        img.setAttribute('loading', 'lazy');
        img.setAttribute('fetchpriority', 'low');
      }
    });
  }

  function releaseCollectionBeforeProductNavigation(event) {
    if (!isMobile() || !/^\/collections(\/|$)/.test(window.location.pathname)) return;

    var link = event.target.closest && event.target.closest('a[href*="/products/"]');
    if (!link) return;

    var targetUrl;
    try {
      targetUrl = new URL(link.getAttribute('href'), window.location.origin);
    } catch (error) {
      return;
    }

    if (targetUrl.origin !== window.location.origin || targetUrl.pathname.indexOf('/products/') !== 0) return;
    if (link.dataset.bgtcgNavigating === 'true') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    link.dataset.bgtcgNavigating = 'true';
    document.documentElement.classList.add('bgtcg-mobile-product-navigation');

    document.querySelectorAll('#ProductGridContainer img, .product-grid img').forEach(function(img) {
      img.removeAttribute('src');
      img.removeAttribute('srcset');
    });

    document.querySelectorAll('#ProductGridContainer .grid__item, .product-grid .grid__item').forEach(function(item) {
      if (!item.contains(link)) item.remove();
    });

    window.setTimeout(function() {
      window.location.href = targetUrl.href;
    }, 30);
  }

  markMobileStablePage();
  guardReloadMethods();
  document.addEventListener('click', releaseCollectionBeforeProductNavigation, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      trimMobileCollection();
      stabilizeMobileImages();
      buildMobileRaritySections();
      window.setTimeout(buildMobileRaritySections, 400);
      window.setTimeout(buildMobileRaritySections, 1200);
    });
  } else {
    trimMobileCollection();
    stabilizeMobileImages();
    buildMobileRaritySections();
    window.setTimeout(buildMobileRaritySections, 400);
    window.setTimeout(buildMobileRaritySections, 1200);
  }

  window.addEventListener('pageshow', function() {
    trimMobileCollection();
    stabilizeMobileImages();
    buildMobileRaritySections();
  });
})();
